/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Station_Work_Summary_UpcomingInputs */

const vi_station_work_summary_upcoming = /** @type {(inputs: Station_Work_Summary_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sắp tới`)
};

/**

* @param {Station_Work_Summary_UpcomingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const station_work_summary_upcoming = /** @type {((inputs?: Station_Work_Summary_UpcomingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Station_Work_Summary_UpcomingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_station_work_summary_upcoming(inputs)
});